import { ListBulletIcon, WalletIcon, Cog6ToothIcon } from '@heroicons/react/24/solid';
import Routes from '@/router/Routes.ts';

export const navData = [
  {
    title: 'navbar.executiveSurface',
    path: Routes.DASHBOARD,
    icon: <ListBulletIcon />,
  },
  {
    title: 'navbar.sessionArchive',
    path: Routes.SESSION_ARCHIVE,
    icon: <WalletIcon />,
  },
  {
    title: 'navbar.account',
    path: Routes.ACCOUNT,
    icon: <Cog6ToothIcon />,
  },
];
